export class ContractsProductsBridge {
	Id?: number;
	ContractId: number;
	ProductTypeId: number;
}